"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let AccountCoinModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.coin = 0;
    this.invite_url = "";
    this.today_gain = 0;
    this.total_gain = 0;
  }
};
AccountCoinModel.model = "account_coin";
AccountCoinModel = __decorateClass([
  Annotation.ModelMeta
], AccountCoinModel);
export let AccountNumberModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.coin = 0;
    this.count = 0;
    this.coupon_amount = 0;
    this.coupon_extension_count = 0;
    this.extensionCount = 0;
    this.invite_url = "";
  }
};
AccountNumberModel.model = "extension.statistics";
AccountNumberModel = __decorateClass([
  Annotation.ModelMeta
], AccountNumberModel);
export let CoinHistoryModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.guid = "";
    this.present_count = 0;
    this.price = 0;
    this.spec_goods_number = 0;
    this.spec_name = "";
    this.type = "";
  }
};
CoinHistoryModel.model = "coin.history";
CoinHistoryModel = __decorateClass([
  Annotation.ModelMeta
], CoinHistoryModel);
export let CoinNewHistoryModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.invitee = "";
    this.coupon = "";
    this.coupon_end_time = 0;
    this.created_time = 0;
  }
};
CoinNewHistoryModel.model = "coin.history";
CoinNewHistoryModel = __decorateClass([
  Annotation.ModelMeta
], CoinNewHistoryModel);
